import classnames from 'classnames';
import { StatusLabelStatus } from '../../../common/enums/statusLabelStatus';
import { translateKey } from '../../translate';
import { Icon, IconColor } from './common';

interface IStatusLabelIconProps {
    small?: boolean;
    statusLabel: StatusLabelStatus | undefined;
}

export function StatusLabelIcon(props: IStatusLabelIconProps) {
    if (!props.statusLabel) {
        return null;
    }

    let icon: string;
    let color: IconColor | undefined;
    let statusBadge: string | undefined;

    switch (props.statusLabel) {
        case StatusLabelStatus.closed:
        case StatusLabelStatus.supervised:
        case StatusLabelStatus.sent:
        case StatusLabelStatus.cancelled:
        case StatusLabelStatus.completed:
        case StatusLabelStatus.aborted:
        case StatusLabelStatus.analyzed:
        case StatusLabelStatus.acceptedRequester:
        case StatusLabelStatus.rejected:
        case StatusLabelStatus.rejectedAndResent:
        case StatusLabelStatus.rejectedAndArchived:
            icon = 'closed';
            statusBadge = 'badge';
            break;
        case StatusLabelStatus.requested:
        case StatusLabelStatus.inProgress:
        case StatusLabelStatus.beingPerformed:
        case StatusLabelStatus.beingGraded:
        case StatusLabelStatus.withAdmin:
        case StatusLabelStatus.withColleague:
        case StatusLabelStatus.withBiometrician:
        case StatusLabelStatus.withGrader:
        case StatusLabelStatus.withSpecialist:
        case StatusLabelStatus.withSupervisor:
        case StatusLabelStatus.sentFirstRound:
        case StatusLabelStatus.answeredFirstRound:
        case StatusLabelStatus.sentSecondRound:
        case StatusLabelStatus.answeredSecondRound:
        case StatusLabelStatus.withPatient:
        case StatusLabelStatus.dataTransferred:
        case StatusLabelStatus.assetNeeded:
        case StatusLabelStatus.withAnalysis:
        case StatusLabelStatus.inAnalysis:
        case StatusLabelStatus.dischargeSent:
        case StatusLabelStatus.intakeSent:
        case StatusLabelStatus.intakeCompleted:
        case StatusLabelStatus.newContact:
        case StatusLabelStatus.invited:
        case StatusLabelStatus.started:
        case StatusLabelStatus.notYetSent:
            icon = 'active';
            statusBadge = 'badge';
            break;
        case StatusLabelStatus.draftRequest:
        case StatusLabelStatus.toProcess:
        case StatusLabelStatus.toAccept:
        case StatusLabelStatus.toAcceptReferral:
        case StatusLabelStatus.dischargeCompleted:
        case StatusLabelStatus.dischargeDraft:
        case StatusLabelStatus.intakeDraft:
        case StatusLabelStatus.accepted:
        case StatusLabelStatus.toPerform:
        case StatusLabelStatus.toGrade:
        case StatusLabelStatus.saved:
        case StatusLabelStatus.toSupervise:
        case StatusLabelStatus.answered:
        case StatusLabelStatus.draftConsult:
        case StatusLabelStatus.toAnswer:
        case StatusLabelStatus.toAnalyze:
        case StatusLabelStatus.draftContact:
        case StatusLabelStatus.draftCounseling:
            icon = 'todo';
            color = IconColor.primary;
            statusBadge = 'badge badge-todo';
            break;
        case StatusLabelStatus.draftReferral:
            icon = 'referral';
            color = IconColor.primary;
            statusBadge = 'badge badge-todo';
            break;
        default:
            throw new Error(`StatusLabelIcon '${props.statusLabel}' but no icon is available`);
    }

    return (
        <div className={classnames('status-label', props.small ? 'small' : '')}>
            <Icon
                color={color}
                icon={icon}
            />
            <span className={statusBadge}>{translateKey(`StatusLabelEnum.${props.statusLabel}`)}</span>
        </div>
    );
}
